import Clazz from '../../common/Clazz';

/**
 * 操作基类
 */
export default class Operation extends Clazz {
    /**
     * 初始化方法
     * @param  {object} editResult 操作对象
     * @param  {string} description 操作描述
     * @param  {object} options 可选项
     * @return {undefined}
     */
    constructor(editResult, description, options) {
        super(options);

        this.onRedo = this.options.onRedo || null;
        this.onUndo = this.options.onUndo || null;

        this.editResult = editResult;
        this.description = description;
    }

    /**
     * 判断本次操作操作是否可以执行
     * @return {bool}  布尔值，指示操作是否可以执行
     */
    canDo() {
        return true;
    }

    /**
     * 操作方法，子类需要重写此方法
     * @return {undefined}
     */
    redo() {
        this.onRedo(this);
    }

    /**
     * 撤销上一次操作的方法，子类需要重写此方法
     * @return {undefined}
     */
    undo() {
        this.onUndo(this);
    }
}
